import { ClassNames } from '@emotion/react';
import React, { useState, useEffect } from 'react';
import useStyles from './Summary.style';
import summaryData from '../../assets/svg/summary-data.svg';
import summaryCart from '../../assets/svg/summary-cart.svg';
import summaryAdditional from '../../assets/svg/summary-additional.svg';
import CartItem from '../CartItem/CartItem';
import getCpt from '../../api/getCpt';
import { parse } from 'date-fns';

const Summary = ({ cart, questionnaireData, personalData }) => {
  const classes = useStyles();

  const [mealPrice, setMealPrice] = useState(true);
  const [loading, setLoading] = useState(true);
  const [mealsPrice, setMealsPrice] = useState(0.0);

  useEffect(() => {
    getCpt(`pages/319?_fields=acf`).then((result) => {
      setMealPrice(result.acf.koszt_posilku);
      setLoading(false);
      // console.log(result);
    });
  }, []);

  useEffect(() => {
    if (questionnaireData.meals === true && loading === false) {
      let freeMeal = Math.floor(
        (parseInt(questionnaireData.peopleNumber) +
          parseInt(questionnaireData.guardiansNumber)) /
          15
      );
      console.log('freeMeal: ' + freeMeal);
      let price =
        parseFloat(mealPrice) *
          parseInt(questionnaireData.days) *
          (parseInt(questionnaireData.peopleNumber) +
            parseInt(questionnaireData.guardiansNumber)) -
        freeMeal * parseFloat(mealPrice) * parseInt(questionnaireData.days);
      console.log(price);
      setMealsPrice(price.toFixed(2));
    }
  }, [loading]);

  function calcPrice() {
    let price = 0;
    if (cart.length > 0) {
      for (let i = 0; i < cart.length; i++) {
        price = price + cart[i].price;
      }
    }
    return (parseFloat(price) + parseFloat(mealsPrice)).toFixed(2);
  }

  return (
    <>
      <div className={classes.summaryBox + ' ' + classes.summaryCart}>
        <div className={classes.title}>
          <img src={summaryCart} alt="" />
          <p>
            Zapytanie wysłane! Poniżej znajdują się wybrane przez Ciebie usługi
          </p>
        </div>
        <div className={classes.summaryInfo}>
          {cart.length > 0 && (
            <>
              {cart.map(
                (cartItem) =>
                  (cartItem = (
                    <div className={classes.cartItem}>
                      <div>
                        <p>{cartItem.title}</p>
                        <span>{cartItem.package} </span>
                      </div>
                      <p className="price">{cartItem.price} zł</p>
                    </div>
                  ))
              )}
            </>
          )}
          <div className={classes.cartItem}>
            <div>
              <p>SUMA</p>
              <span>
                {questionnaireData.meals === true &&
                  `Z wyżywieniem ( Wyżywienie na ${questionnaireData.days} dni dla
                ${questionnaireData.peopleNumber} osób oraz
                ${questionnaireData.guardiansNumber} opiekunów )`}
              </span>
            </div>
            <p className="price">{calcPrice()} zł</p>
          </div>
          <div className={classes.cartItem}>
            <div>
              <p>SUMA NA OSOBĘ</p>
              <span>
                {questionnaireData.meals === true && `Z wyżywieniem `}
              </span>
            </div>
            <p className="price">
              {(calcPrice() / questionnaireData.peopleNumber).toFixed(2)} zł
            </p>
          </div>
        </div>
      </div>

      <div className={classes.summaryBox}>
        <div className={classes.title}>
          <img src={summaryAdditional} alt="" />
          <p>Dodatkowe usługi</p>
        </div>
        <div className={classes.summaryInfo}>
          {/* <div className={classes.cartItem}>
            <div>
              <p>Wyżywienie </p>
              <span>
                Wyżywienie na {questionnaireData.days} dni dla{' '}
                {questionnaireData.peopleNumber} osób oraz{' '}
                {questionnaireData.guardiansNumber} opiekunów
              </span>
            </div>
            <p className="price">
              {questionnaireData.meals === true
                ? !loading && mealsPrice + ' zł'
                : 'Nie'}
            </p>
          </div> */}

          <div className={classes.cartItem}>
            <div>
              <p>Transport</p>
              <span>Transport do ośrodka Hullo liczony jest indywidualnie</span>
            </div>
            <p className="price">
              {' '}
              {questionnaireData.transport === true ? 'Tak' : 'Nie'}
            </p>
          </div>
        </div>
      </div>
      <div className={classes.summaryBox}>
        <div className={classes.title}>
          <img src={summaryData} alt="" />
          <p>Poniżej znajdują się Twoje dane</p>
        </div>
        <div className={classes.summaryInfo}>
          <div>
            <div>
              <span>Cel podróży</span>
              <p>{questionnaireData.target}</p>
            </div>
            <div>
              <span>Liczba osób korzystającyh z atrakcji</span>
              <p>{questionnaireData.peopleNumber}</p>
            </div>
            <div>
              <span>Liczba opiekunów</span>
              <p>{questionnaireData.guardiansNumber}</p>
            </div>
            <div>
              <span>Data przyjazdu</span>
              <p>
                {questionnaireData.startDate &&
                  questionnaireData.startDate.toLocaleDateString('pl')}
              </p>
            </div>
            <div>
              <span>Grupa wiekowa</span>
              <p>{questionnaireData.ageGroup}</p>
            </div>
            <div>
              <span>Chcę skorzystać z hotelu</span>
              <p>{questionnaireData.hotel === true ? 'Tak' : 'Nie'}</p>
            </div>
          </div>
          <div>
            <div>
              <span>Imię oraz nazwisko</span>
              <p>
                {personalData.name} {personalData.surname}
              </p>
            </div>
            <div>
              <span>Adres e-mail</span>
              <p>{personalData.mail}</p>
            </div>
            <div>
              <span>Numer telefonu</span>
              <p>{personalData.phone}</p>
            </div>
            <div>
              <span>Nazwa placówki</span>
              <p>{personalData.company}</p>
            </div>
            <div>
              <span>Miejscowość</span>
              <p>{personalData.city}</p>
            </div>
            <div>
              <span>Informacje dodatkowe</span>
              <p>{personalData.addInfo}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Summary;
